import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AbstractControl, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, ValidationErrors, Validators } from '@angular/forms';

function passwordRepeatMatchValidator(group: AbstractControl): ValidationErrors | null {
  const password = group.get('password')?.value;
  const passwordRepeat = group.get('passwordRepeat')?.value;
  return password === passwordRepeat ? null : { failedValidator: 'passwordRepeatMatchValidator' };
}
import { NbInputModule, NbButtonModule } from '@nebular/theme';
import { PasswordValidator, PASSWORD_MIN_LENGTH, PASSWORD_MAX_LENGTH } from '../../utils/validators.validator';
import { PasswordCriteriaComponent } from '../password-criteria/password-criteria.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { StatusIconDirective } from '../../directives/status-icon.directive';

@Component({
  selector: 'app-password-set',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, NbInputModule, NbButtonModule, TranslateModule, PasswordCriteriaComponent, StatusIconDirective],
  templateUrl: './password-set.component.html',
  styleUrls: ['./password-set.component.scss']
})
export class PasswordSetComponent implements OnInit {
  @Input() submitButtonText: string | null = null;
  @Input() showSubmitButton = true;
  @Input() disabled = false;
  
  @Output() passwordSubmit = new EventEmitter<string>();
  @Output() validityChange = new EventEmitter<boolean>();

  passwordForm: FormGroup;
  PASSWORD_MIN_LENGTH = PASSWORD_MIN_LENGTH;
  PASSWORD_MAX_LENGTH = PASSWORD_MAX_LENGTH;

  constructor(private fb: FormBuilder, public translate: TranslateService) {
    this.passwordForm = this.fb.group({
      password: ['', [Validators.required, PasswordValidator.strongDetailed]],
      passwordRepeat: ['', [Validators.required]]
    }, { validators: [passwordRepeatMatchValidator] });

    // Emit validity changes
    this.passwordForm.statusChanges.subscribe(() => {
      const isValid = this.passwordForm.valid && this.passwordsMatch;
      this.validityChange.emit(isValid);
    });
  }

  ngOnInit(): void {
    if (this.submitButtonText === null) {
      this.submitButtonText = this.translate.instant('passwordSet.submit');
    }
  }

  get passwordCtrl() {
    return this.passwordForm.get('password');
  }

  get passwordRepeatCtrl() {
    return this.passwordForm.get('passwordRepeat');
  }

  get passwordsMatch(): boolean {
    return this.passwordCtrl?.value === this.passwordRepeatCtrl?.value;
  }

  get isValid(): boolean {
    return this.passwordForm.valid && this.passwordsMatch;
  }

  // Get the password value (for parent components that need it)
  getPassword(): string {
    return this.passwordCtrl?.value || '';
  }

  submit() {
    if (this.isValid) {
      this.passwordSubmit.emit(this.passwordCtrl?.value);
    }
  }

  reset() {
    this.passwordForm.reset();
  }
}